var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartbroken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 84,
    viewBox: "0 0 82 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1112777"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M45.1429 84.0017C62.6167 84.0017 76.782 83.6664 76.782 83.2528C76.782 82.8392 62.6167 82.5039 45.1429 82.5039C27.6692 82.5039 13.5039 82.8392 13.5039 83.2528C13.5039 83.6664 27.6692 84.0017 45.1429 84.0017Z",
    fill: "#D2E7FC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M60.9875 82.6421L56.2495 75.2188C56.2495 75.2188 63.3383 81.4629 63.3383 81.3447C63.3383 81.2264 68.7357 69.3262 68.7357 69.3262C68.7357 69.3262 66.0024 80.4841 66.0815 82.1231C66.0815 82.1231 68.8181 79.6432 70.1138 79.4396C71.4096 79.2359 68.3334 81.7684 68.3367 83.2563H61.2743L60.9875 82.6421Z",
    fill: "#4CD8BD"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_3",
    opacity: 0.96,
    filter: "url(#filter0_b_14068_337791)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.6618 63.3918L46.1409 68.5717C43.1768 67.202 38.297 64.9224 33.0217 62.3604C29.4674 60.6327 25.7351 58.7769 22.2896 56.9835C22.2632 56.967 22.2335 56.9539 22.2072 56.9408C21.4686 56.5565 20.7465 56.1754 20.0377 55.7977C15.4118 53.331 11.5509 51.0711 9.75068 49.5471C6.03814 47.031 3.04437 43.1946 1.49143 38.4548C-1.98701 27.806 3.1235 16.6251 12.9093 13.4752C19.4442 11.3664 26.411 13.3766 31.3599 18.1229L30.2785 26.4265L35.3593 29.9575L33.7338 36.6516L39.0224 40.7968L38.1651 47.1788L37.9179 49.0248L38.5146 49.4124L42.8965 52.2503L41.9766 56.4908L41.5051 58.6652L41.3798 59.2499L46.6618 63.3918Z",
    fill: "#2568B8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_4",
    opacity: 0.96,
    filter: "url(#filter1_b_14068_337791)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.5511 21.4313C81.2214 26.4075 79.2728 30.8615 76.2988 34.2118C74.6404 36.5407 70.3179 40.6629 65.3228 45.0971C59.1902 50.5431 52.0453 56.4587 47.581 60.1079C46.9051 60.6598 46.2886 61.1623 45.7479 61.5992L43.9575 56.7051L48.0525 51.3872L44.8444 44.9789L48.8669 40.63L45.7577 32.9276L49.8527 27.6097L46.6216 21.5233L50.6671 16.8493L47.5646 9.06795C51.1881 3.26399 57.4394 -0.401666 64.3007 0.0351914C74.5613 0.682265 82.2831 10.2603 81.5511 21.4313Z",
    fill: "#2568B8"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_14068_337791",
    x: -45.8249,
    y: -33.5842,
    width: 138.711,
    height: 148.381,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 23.1124
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_14068_337791"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_14068_337791",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_14068_337791",
    x: -2.26731,
    y: -46.2248,
    width: 130.091,
    height: 154.049,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 23.1124
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_14068_337791"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_14068_337791",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartbroken);
export default __webpack_public_path__ + "static/media/heartbroken.b4b906e5f0c57944914e39ebba9b8d3e.svg";
export { ForwardRef as ReactComponent };